import React from 'react';
import { TextFieldProps } from '../../../types/DesignSystem/TextField';
import FieldTitle from '../FieldTitle/FieldTitle';
import { CopyIcon } from '../../../assests/GmsIcons';
import Typography from '../Typography/Typography';
import OverlayIcon from '../../GMS/Rules/Components/OverlayIcon';

const TextField: React.FC<TextFieldProps> = ({
  label,
  placeholder = '',
  value = '',
  onChange,
  onBlur,
  maxLength,
  disabled = false,
  required = false,
  error = false,
  helperText = '',
  type = 'text',
  showCopyButton = false,
  onCopy,
  additionalInfo = '',
  infoMessage = '',
  className = '',
  minValue,
  maxValue
}) => {
  const handleCopy = () => {
    if (onCopy) {
      onCopy();
    } else if (value) {
      navigator.clipboard.writeText(value);
    }
  };

  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-gap-2">
        <FieldTitle label={label} required={required} className="tw-mb-2" />
        {infoMessage && (
          <div className="tw-mb-2">
            <OverlayIcon message={infoMessage} placement="top" />
          </div>
        )}
      </div>

      <div className="tw-relative tw-flex tw-items-center">
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => {
            if (maxValue) { if (Number(e.target.value) > maxValue) { onChange?.(maxValue.toString()); return; } }
            onChange?.(e.target.value)
          }}
          onBlur={onBlur}
          maxLength={maxLength}
          disabled={disabled}
          min={minValue}
          max={maxValue}
          className={`tw-w-full tw-px-3 tw-py-2 tw-border tw-border-grey-200 tw-rounded-1 tw-text-body-primary tw-text-grey-900 tw-placeholder-grey-500 tw-transition-colors
            ${disabled
              ? 'tw-bg-grey-100 tw-text-grey-500 tw-cursor-not-allowed'
              : 'tw-bg-white hover:tw-border-grey-300 focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500'
            }
            ${error ? 'tw-border-red-error-900 focus:tw-ring-red-error-900' : ''}
          `}
        />

        {showCopyButton && (
          <button
            onClick={handleCopy}
            className="tw-absolute tw-right-3 tw-text-grey-600 hover:tw-text-grey-900 tw-transition-colors tw-p-1"
            title="Copy to clipboard"
          >
            <CopyIcon />
          </button>
        )}
      </div>

      {helperText && (
        <Typography
          variant="caption-metadata"
          className={`tw-mt-1 ${error ? 'tw-text-red-error-900' : 'tw-text-grey-600'}`}
        >
          {helperText}
        </Typography>
      )}

      {additionalInfo && (
        <Typography
          variant="caption-metadata"
          className="tw-mt-2 tw-text-grey-600"
        >
          {additionalInfo}
        </Typography>
      )}
    </div>
  );
};

export default TextField;
